import eyeIcon from './../Assets/icons/eye 1.svg'
import editIcon from './../Assets/icons/Un-Checkbox.svg'

export const TABLE_HEADERS = [
    // "Sr No.",
    "Dealer Name",
    "PO Detail No.",
    "Dealer Code",
    "Vin No",
    "Product Name",
    "Warranty",
    "Warranty From",
    "Warranty To",
    "Remark",
    "Status",
    "Action"

  ];
  
  export const TABLE_DATA = [
    { id: 1, days: "One Month", description:"lorem ipsum",status: "Active", actions: "Edit/Delete" },
    { id: 2, days: "Two Month", description:"lorem ipsum",  status: "Inactive", actions: "Edit/Delete" },
    { id: 3, days: "Three Month", description:"lorem ipsum",  status: "Active", actions: "Edit/Delete" },
  ];
  
  export const keyMapping = {
    // "Sr No.": "Sr No.",
    "Dealer Name": "dealer_name",
   "Dealer Name":"dealer_name",
    "PO Detail No.":"podetail_number",
    "Dealer Code":"dealer_code",
    "Vin No":"vin_no",
    "Product Name":"productname",
    "Warranty":"warranty",
    "Warranty From":"warrantyFrom",
    "Warranty To":"warrantyTo",
    "Remark":"remark",
    "Status":"status",
    "Action": [
        { type: "view", icon: eyeIcon, label: "View" },
        
      ]
  };